import { isEqual } from 'lodash';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import { ComponentStylingInterface, StageComponentInterface } from '../../../../interfaces/pagebuilder';
import { PageBuilderSettingsTable } from '../../pageBuilder/Settings/PageBuilderSettingsTable';
import { useSelector } from '../../../../reduxToolkit/typedRedux';

const MBWStageStyling = ({ component, onChange }: ComponentStylingInterface<StageComponentInterface>) => {
  const { t } = useTranslation();
  const event = useSelector((state) => state.common.event ?? state.admin.event);

  return (
    <PageBuilderSettingsTable
      sections={[
        {
          settings: [
            {
              type: 'color',
              label: t('pagebuilder:events-list-settings.button-color'),
              path: 'customStyling.buttonColor',
              defaultValue: component?.customStyling?.buttonColor ?? event?.template?.mainColor,
            },
            {
              type: 'color',
              label: t('pagebuilder:events-list-settings.button-text'),
              path: 'customStyling.buttonTextColor',
              defaultValue: component?.customStyling?.buttonTextColor ?? event?.template?.mainButtonTextColor,
            },
            {
              type: 'color',
              label: t('pagebuilder:stage-sidepanel-background'),
              path: 'customStyling.sidePanelBackground',
            },
          ],
        },
      ]}
      onChange={onChange}
      component={component}
      showTitleAndDescription={false}
    />
  );
};
export default React.memo(MBWStageStyling, (prevprop, newprop) => isEqual(prevprop, newprop));
